export default __webpack_public_path__ + "eb64b0c6ccc46c61d25182c008a6bbce662b962e/45b3d9bead8ca49501a2a3b80e7cc1ac.png";